import React from 'react';

import GooglePlayLogo from '@images/stores/google-play-with-text-black.svg';
import AppStoreLogo from '@images/stores/app-store-with-text-black.svg';

import ReviewCardBase from './review-card';

export const ReviewCard = {
  Google: ({ author, comment, rating }) => (
    <ReviewCardBase
      logoImage={{ src: GooglePlayLogo, alt: 'Google Play' }}
      author={author}
      comment={comment}
      rating={rating}
    />
  ),
  Apple: ({ author, comment, rating }) => (
    <ReviewCardBase
      logoImage={{ src: AppStoreLogo, alt: 'App Store' }}
      author={author}
      comment={comment}
      rating={rating}
    />
  ),
};
